// Used for old User inside company typehead/bloodhound
// to remove with autocomplete_user_typehead
import { htmlSafe } from 'helpers/htmlSafe';

const UserAutocompleteTemplate = ({
  full_name: fullName,
  headline,
  new_photo: newPhoto,
}) => (
  <div className="muted-link rounded search-item soft-half">
    <div className="flexbox">
      <div className="flexbox__item v-middle">
        {newPhoto?.thumbnail_url && (
          <div
            data-testid="user-avatar"
            className="block"
            style={{
              backgroundImage: `url(${newPhoto?.thumbnail_url})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              height: '42px',
              width: '42px',
            }}
          />
        )}
      </div>
      <div className="flexbox__item ten-twelfths soft-half--left v-middle">
        <div className="weight--bold">
          {fullName}
          {headline &&
            (headline.length > 80 ? (
              <div className="color-gray">
                {htmlSafe(headline.substr(0, 80))}...
              </div>
            ) : (
              <div className="color-gray">{htmlSafe(headline)}...</div>
            ))}
        </div>
      </div>
    </div>
  </div>
);

export default UserAutocompleteTemplate;
